import buttons from '@lucid/theme/src/theme/components/buttons';
import colors from '@lucid/theme/src/theme/colors';

const baseVariantShared = {
  borderRadius: '5px',
  margin: '1rem 0',
  outline: 'none',
};

const primaryShared = {
  ...baseVariantShared,
  color: 'white',
  backgroundColor: 'coolGrey.100',
  position: 'relative',
  borderWidth: '1px',
  borderStyle: 'solid',
  borderColor: 'coolGrey.100',
  '&:focus': {
    borderColor: 'coolGrey.10',
    borderWidth: '4px',
    borderRadius: '8px',
    margin: 'calc(1rem - 3px) 0',
    outline: '2px solid',
    outlineOffset: '0',
    outlineColor: 'coolGrey.100',
  },
  '&:hover, &:active': {
    color: 'coolGrey.100',
    outline: '2px solid',
    outlineColor: 'coolGrey.60',
    borderColor: 'transparent',
    backgroundColor: 'coolGrey.10',
  },
  '&:disabled, &[aria-disabled="true"]': {
    color: 'white',
    backgroundColor: 'coolGrey.100',
    borderWidth: '1px',
    borderStyle: 'solid',
    borderColor: 'coolGrey.100',
    borderRadius: '4px',
    boxShadow: 'none',
    outline: 'none',
    cursor: 'default',
    opacity: '0.35',
  },
};

const secondaryShared = {
  ...baseVariantShared,
  color: 'coolGrey.100',
  backgroundColor: 'white',
  borderWidth: '1px',
  borderStyle: 'solid',
  borderColor: 'coolGrey.100',
  '&:focus': {
    color: 'coolGrey.100',
    borderColor: 'coolGrey.10',
    borderWidth: '4px',
    borderRadius: '8px',
    margin: 'calc(1rem - 3px) 0',
    outline: '2px solid',
    outlineColor: 'coolGrey.100',
    outlineOffset: '0',
    boxShadow: `inset 0 0 0 1px ${colors.coolGrey[100]}`,
  },
  '&:hover, &:active': {
    backgroundColor: 'coolGrey.10',
    color: 'coolGrey.100',
    outline: '2px solid',
    outlineColor: 'coolGrey.60',
    borderColor: 'transparent',
    boxShadow: 'none',
  },
  '&:disabled, &[aria-disabled="true"]': {
    color: 'coolGrey.100',
    backgroundColor: 'white',
    borderWidth: '1px',
    borderStyle: 'solid',
    borderColor: 'coolGrey.100',
    boxShadow: 'none',
    cursor: 'default',
    opacity: '0.35',
  },
};

const {
  products: { chart: chartBase, spark: sparkBase, scale: scaleBase, co: coBase },
} = buttons;

const consolidatedVariants = {
  primary: {
    ...primaryShared,
  },
  primaryAlternate: {
    ...primaryShared,
  },
  secondary: {
    ...secondaryShared,
  },
  secondaryAlternate: {
    ...secondaryShared,
  },
};

const updatedButtons = {
  products: {
    chart: {
      ...chartBase,
      ...consolidatedVariants,
    },
    chartblog: {
      ...chartBase,
      ...consolidatedVariants,
    },
    co: {
      ...coBase,
      ...consolidatedVariants,
    },
    scale: {
      ...scaleBase,
      ...consolidatedVariants,
    },
    spark: {
      ...sparkBase,
      ...consolidatedVariants,
    },
  },
};

export default updatedButtons;
